import React, { useRef, useState, useEffect } from 'react';
import TablaPersonas from './tablaPersonas';

export const Personas = (props) => {

    return (
        <div className='container-fluid rounded p-0 m-0'>
        <div className='container-fluid w-100 h-100 p-0 m-0'>
               <TablaPersonas/>
           </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/personas.js